export const TICK_RATE = 60;
export const DT = 1 / TICK_RATE;
export const MAX_CARS = 8;
/** Version of the simulation rules; bump when physics changes incompatibly. */
export const SIM_VERSION = 24;
